export default __webpack_public_path__ + "static/media/iconRemoverLink.f87eea6e.svg";